import React, { type SyntheticEvent, useRef } from "react";
import * as Styles from "../../../../../../common-deprecated/styles/v2/toyota/components/Pill";
import * as Text from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import type { PosType } from "../../../../../../common-deprecated/types/CommonTypes";
import { getOffsetRect } from "../../../../../../shared-logic/features/filters/utils/helpers";
import { SrOnly } from "../../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";
import { useModelFilterLabel } from "../../../utils/labels";

type FilterPillButtonType = {
    children: React.ReactNode;
    onClick: (pos: PosType) => void;
    closeFn?: () => void;
    isSelected: boolean;
    disabled?: boolean;
    ariaControlsId?: string;
};

const FilterPillButton = (props: FilterPillButtonType): JSX.Element => {
    const { children, closeFn, onClick, disabled, ariaControlsId, isSelected } = props;

    const pillButtonRef = useRef<HTMLButtonElement>(null);
    const isCloseFn = !!closeFn;
    const [addFilterLabel] = useModelFilterLabel(["modelfilterA11yButtonAddFilter"]);

    return (
        <Styles.Wrapper
            type="button"
            role="button"
            hasIconRight
            onClick={() => {
                if (!disabled && pillButtonRef.current) {
                    const { left: x, bottom: y } = getOffsetRect(pillButtonRef.current);

                    onClick({ x, y });
                }
            }}
            disabled={!!disabled}
            isActive={!!closeFn}
            isSelected={isSelected}
            ref={pillButtonRef}
            aria-controls={ariaControlsId}
            aria-expanded={isSelected}
        >
            <SrOnly>{addFilterLabel}</SrOnly>
            <Text.Button>{children}</Text.Button>
            {/*
            Info: Do not add a tabindex on the close icon here, it would result in a button inside of a button. This button can be ignored as the modals themselves have a remove filter option
            */}
            <IconWrapper
                onClick={
                    closeFn
                        ? (event: SyntheticEvent) => {
                              // Prevent click on wrapper
                              event.preventDefault();
                              event.stopPropagation();
                              closeFn();
                          }
                        : undefined
                }
                aria-hidden="true"
            >
                <Icon variant={isCloseFn ? "close" : "plus"} />
            </IconWrapper>
        </Styles.Wrapper>
    );
};

export default FilterPillButton;
